<div class="row">
  <div class="col-lg-12 col-md-12 col-sm-12 col-12 container-style">
    <form [formGroup]="formPrintingRange">
      <div class="col-lg-12 me-1 me-lg-0">
        <div class="row mt-1">
          <div class="custom-container col-lg-4 col-md-4 col-sm-4 col-6">
            <app-custom-input-number formControlName="invoicingCutoff" [labelText]="'Corte'" [recovery]="true"
              (onChangeNumber)="changeInvoicingCutoff()"></app-custom-input-number>
          </div>
          <div class="custom-container col-lg-4 col-md-4 col-sm-4 col-6">
            <app-custom-input-number formControlName="consecutiveInitial" [labelText]="'Inicial'"
              [required]="true"></app-custom-input-number>
          </div>
          <div class="custom-container col-lg-4 col-md-4 col-sm-4 col-6">
            <app-custom-input-number formControlName="consecutiveFinal" [labelText]="'Final'"
              [required]="true"></app-custom-input-number>
          </div>
          <div class="custom-container col-lg-8 col-md-8 col-sm-8 col-6">
            <app-custom-select formControlName="invoiceTraffic" [labelText]="'Tráfico Fra.'" [list]="listInvoiceTraffic"
              [required]="true"></app-custom-select>
          </div>
          <div class="col-lg-4 col-md-4 col-sm-4 col-12 mt-2 d-flex justify-content-end align-items-end">
            <app-custom-button [title]="'Imprimir'" [label]="'Imprimir'" [variant]="undefined"
              (onClick)="send()"></app-custom-button>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>